

















































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import wxTextTable from "@/views/tenants/tenantsView/wx-message_TextTable.vue"; //文本回复表格

import wxImgTable from "@/views/tenants/tenantsView/wx-message_ImgTable.vue"; //图片回复表格

import wxImgTextTable from "@/views/tenants/tenantsView/wx-message_ImgTextTable.vue"; //图文回复回复表格

import wxvoidTable from "@/views/tenants/tenantsView/wx-message_voidTable.vue"; //语音回复表格
import wxwxEventClick from "@/views/tenants/tenantsView/wx-message_EventClick.vue"; //微信菜单点击事件

import wxGroupTable from "@/views/tenants/tenantsView/wx-message_GroupTable.vue"; //群发回复表格

import wxModelTTable from "@/views/tenants/tenantsView/wx-message_ModelTable.vue"; //模板回复表格
import wxModelGroupTable from "@/views/tenants/tenantsView/wx-message_ModelGroupTable.vue"; //模板群发回复表格
import Bus from "@/JS/Bus";
@Component({
  components: {
    wxTextTable,
    wxImgTable,
    wxImgTextTable,
    wxvoidTable,
    wxwxEventClick,
    wxGroupTable,
    wxModelTTable,
    wxModelGroupTable
  }
})
export default class extends Vue {
  //注入数据 @Provide()
  @Provide()
  @Provide()
  private activeName: any = "first";
  private clickTabs() {
    //console.log(this.activeName);
    switch (this.activeName) {
      case "first":
        this.$router.push("/appaccount/templateMessage?activeName=first");
        (this as any).$refs.first.refresh();
        break;
      case "second":
        this.$router.push("/appaccount/templateMessage?activeName=second");
        (this as any).$refs.second.refresh();
        break;
      case "third":
        this.$router.push("/appaccount/templateMessage?activeName=third");
        (this as any).$refs.third.refresh();
        break;
      case "four":
        this.$router.push("/appaccount/templateMessage?activeName=four");
        (this as any).$refs.four.refresh();
        break;
      case "five":
        this.$router.push("/appaccount/templateMessage?activeName=five");
        (this as any).$refs.five.refresh();
        break;
      case "six":
        this.$router.push("/appaccount/templateMessage?activeName=six");
        (this as any).$refs.six.refresh();
        break;
      case "seven":
        this.$router.push("/appaccount/templateMessage?activeName=seven");
        (this as any).$refs.seven.refresh();
        break;
      case "eight":
        this.$router.push("/appaccount/templateMessage?activeName=eight");
        (this as any).$refs.eight.refresh();
        break;
    }
  }
  created() {
    console.log(this.$route.query.activeName);
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName;
    }
    const that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", () => {
      that.clickTabs();
    });
  }
}
